import React from "react";
import { Text, Button } from "@fluentui/react-components";
import styles from "@/components/TryAgain/TryAgain.module.css";
import error from "assets/images/svg/error.svg";
import type { TryAgainPropsInterface } from "@/components/TryAgain/TryAgain.types";

export const TryAgain = React.memo((props: TryAgainPropsInterface) => {
  const { title, description, buttonTitle, onClick, className } = props;
  return (
    <div className={styles.container}>
      <img alt={title} src={error} className={className || styles.img} />
      <div className={styles.innerContainer}>
        <Text align="center" weight="bold" size={500}>
          {title}
        </Text>
        <Text align="center">{description}</Text>
      </div>
      {onClick && (
        <Button
          onClick={onClick}
          appearance="primary"
          className={styles.button}
        >
          {buttonTitle}
        </Button>
      )}
    </div>
  );
});

export default TryAgain;
